import { BrowserRouter, Routes, Route } from "react-router-dom"
import { ApolloProvider } from "@apollo/client/react"
import { client } from "@/graphql/client"
import HomePage from "@/pages/HomePage"

export default function App() {
  return (
    <ApolloProvider client={client}>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
        </Routes>
      </BrowserRouter>
    </ApolloProvider>
  )
}
